import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyD3PCQ97yXF8Ym52cdw2TNwW3RNQxYjpuk",
    authDomain: "appalto-v3-21e6a.firebaseapp.com",
    projectId: "appalto-v3-21e6a",
    storageBucket: "appalto-v3-21e6a.firebasestorage.app",
    messagingSenderId: "159658883013",
    appId: "1:159658883013:web:ec3607c0e0bd5d7be9bdac"
  };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Messaging
const messaging = getMessaging(firebaseApp);

// Request Permission and Get Token
export const requestPermission = async () => {
    if (typeof window === "undefined" || !("Notification" in window)) {
        return null;
    }

    if (Notification.permission === "denied") {
        return null;
    }

    try {
        if (Notification.permission !== "granted") {
            const permission = await Notification.requestPermission();

            if (permission !== "granted") {
                return null;
            }
        }

        const token = await getToken(messaging, {
            vapidKey: "BKJR7UGE_zytiPCYOAiZLupFZS-jfHtbs7FH1HJwmMR_PDjDxXPnAJZVokj70ynaqAfdARU82PVmaCtfdhPXKq8", // Replace with your VAPID key
        });
        //console.log("FCM Token:", token);
        return token;
    } catch (err) {
        console.error("Error getting FCM token:", err);
        return null;
    }
};

// Listen for Messages
export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
